export default {
    suppressNavPaths: /\/reports\//,    // top nav of app will be omitted on paths matching this
    icons: {
        // these icons are from https://material.io/tools/icons/
        // that is controlled in the vuetify iconfont setting below
        cancel: "keyboard_arrow_left",
        close: "keyboard_arrow_up",
        open: "keyboard_arrow_down",
        code: "code",
        edit: "create",
        // fold: "unfold_less",
        help: "help_outline",
        job_disabled: "remove_circle_outline",
        job_down: "highlight_off",
        job_up: "check_circle_outline",
        remove: "remove_circle",
        save: "save",
        settings: "settings"
    },
    vuetify: {
        icons: {
            iconfont: 'md'  // https://vuetifyjs.com/en/customization/icons
        },
        theme: {
            // Documentation: https://vuetifyjs.com/en/customization/theme
            warning: "#e65100",
            pass: "#366836",
            fail: "#f03d15",
            warn: "#f60"
        }
    }
};
